import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { UploadedFileViewModel } from 'src/app/components/core/components/uploader/document_uploader.types';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos } from 'src/app/components/core/_infrastructure/types/common';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { PaisService } from '../../../_mantenimiento/general/paises/pais.service';
import { PaisViewModel } from '../../../_mantenimiento/general/paises/pais.types';
import { TipoDocumentacionViewModel } from '../../../_mantenimiento/general/tipodocumentacion/tipodocumentacion.types';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { DocumentosService } from '../documentos/documentos.service';
import { DownloadedFileViewModel, SolicitudDocumentosViewModel, TDocumentoSolicitudViewModel } from '../documentos/documentos.types';
import { EnumCodigosTwTcAcciones, EnumIdsTcEstadoSolicitud, EnumIdsTwTcTipoClonacion } from '../types/enum';
import { of } from 'rxjs';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-documentos-edit-importacion',
    templateUrl: './documentos-edit.component.html',
})
export class DocumentosEditComponent extends ComponentBase implements OnInit, OnDestroy {
    @HostListener('window:beforeunload', ['$event'])
    forceCheckUnload(): boolean {
        // Prevenimos la pérdida de datos, si el usuario recarga accidentalmente la página.
        // Lo controlamos y el navegador le requiere confirmación para finalizar la recarga.
        if (this.filePendingToPurge !== '') {
            this.documentosService.deleteFile(this.filePendingToPurge).subscribe();
        }
        return false;
    }

    editMode = false;
    editTitle = 'Nuevo';

    listTipoDocumentacion: TipoDocumentacionViewModel[];
    listPais: PaisViewModel[];

    listSiNo: SelectItem[];

    solicitudDocumentos: SolicitudDocumentosViewModel;
    documento: TDocumentoSolicitudViewModel;
    uploadedFile: UploadedFileViewModel = new UploadedFileViewModel();
    downloadedFileFromTraces: DownloadedFileViewModel = new DownloadedFileViewModel();

    cols: any[];

    IdEstadoSolicitud: number;
    TipoSolicitudDescripcion: string;
    EstadoSolicitudDescripcion: string;
    EsPredua: boolean;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    tituloTipoSolicitud: string;
    IdTipoSolicitud: number;
    IdResultadoEnvioMuestrasLaboratorio: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorio: string;

    habilitarGuardar = true;
    habilitarVisibilidadSolicitante = true;
    requerirTexto: boolean | null = false;
    requerirFecha: boolean | null = false;
    requerirPais: boolean | null = false;

    visibilitySpinner = false;
    laHeGrabadoYo = false;
    esClonada = false;
    esInspector = false; //para el HTML
    esGrabador = false;
    esSolicitante = false; //para permisos de descarga

    esTipoDocumentoAttachedTraces = false;
    habilitarUploaderComponentFromLocal = false;
    habilitarGridInfoFileDownloadedFromTraces = false; //grid con info del fichero descargado desde TRACES
    habilitarButtonDownloadFileFromTraces = false; //botón Descargar de TRACES, Sí/No

    megaSizeLimit: number;
    private filePendingToPurge = '';
    mensajeYaExisteCF = 'La solicitud ya tiene un documento de tipo Certificado Fitosanitario';

    get sizeLimit() {
        return this.megaSizeLimit * 1024 * 1024;
    }

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public datepipe: DatePipe,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private documentosService: DocumentosService,
        private paisService: PaisService,
        protected configService: ConfigurationService,
    ) {
        super(authService, notificationService, exceptionHandler, configService);

        this.solicitudDocumentos = new SolicitudDocumentosViewModel();
        this.documento = new TDocumentoSolicitudViewModel();
    }

    ngOnInit() {
        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento
        this.documentosService.getTipoDocumentacion().subscribe(res => {
            this.listTipoDocumentacion = res;
        });

        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento.
        this.paisService.getAllPaises().subscribe(res => {
            this.listPais = res;
        });

        this.createForm();

        let id = this.activatedRoute.snapshot.params['id'];
        let idDocumento = this.activatedRoute.snapshot.params['idDocumento'];

        this.guardRefreshPage(id);

        //Para saber si se actua como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitud', id.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());

        this.solicitudService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
            this.laHeGrabadoYo = resultIsGrabada;
            this.esSolicitante = this.isSolicitante && !this.laHeGrabadoYo;
            this.esInspector = this.isInspector; //para el HTML. @author iberdugo - He quitado el !this.laHeGrabadoYo confirmado con Álvaro.
            this.esGrabador = this.isGrabador;
            if (idDocumento) {
                this.documentosService.getDocumento(idDocumento).subscribe(result => {
                    //EDICIÓN

                    this.documento = result;

                    //ver si está descargado desde TRACES o sólo subido desde local
                    this.habilitarGridInfoFileDownloadedFromTraces = this.documento.DocumentDownloadedFromTraces;
                    this.habilitarUploaderComponentFromLocal = !this.documento.DocumentDownloadedFromTraces;

                    this.tituloTipoSolicitud = this.documento.IdTipoSolicitudDescripcion;
                    this.esClonada =
                        this.documento.TwSolicitudJerarquia != null &&
                        this.documento.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;
                    //SI ES RE-IMPORTACION
                    if (this.documento.EsReImportacion) {
                        this.tituloTipoSolicitud += ' - Re-Importación';
                    }
                    //SI ES PREVIA
                    if (this.documento.EsPrevia) {
                        if (
                            this.documento.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                            this.documento.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += ' - Previa';
                        }
                    }

                    this.IdTipoSolicitud = this.documento.IdTipoSolicitud;
                    this.CodigoSolicitud = this.documento.CodigoSolicitud;
                    this.CodigoTipoSolicitud = this.documento.CodigoTipoSolicitud;
                    this.IdEstadoSolicitud = this.documento.IdEstadoSolicitud;
                    this.TipoSolicitudDescripcion = this.documento.IdTipoSolicitudDescripcion;
                    this.EstadoSolicitudDescripcion = this.documento.IdEstadoSolicitudDescripcion;
                    this.IdResultadoEnvioMuestrasLaboratorio = this.documento.IdResultadoEnvioMuestrasLaboratorio;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorio = this.documento.DescripcionIdResultadoEnvioMuestrasLaboratorio;
                    this.EsPredua = this.documento.EsPredua;
                    this.editMode = true;

                    //cargar el objeto necesario según si el documento fue descargado desde TRACES o no
                    if (this.documento.DocumentDownloadedFromTraces) {
                        this.downloadedFileFromTraces.Guid = result.CodigoStorage;
                        this.downloadedFileFromTraces.Name = result.NombreArchivo;
                        this.downloadedFileFromTraces.Size = result.Size!;
                    } else {
                        this.uploadedFile = { ...this.uploadedFile, Guid: result.CodigoStorage, Name: result.NombreArchivo, Size: result.Size! };
                    }

                    this.updateForm();

                    //Si soy Grabador
                    if (this.isGrabador && this.documento.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS, this.documento.IdEstadoSolicitud).Visible &&
                            this.laHeGrabadoYo;
                    } else {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS, this.documento.IdEstadoSolicitud).Visible &&
                            !this.documento.Revisado;
                    }

                    this.habilitarVisibilidadSolicitante = this.habilitarGuardar && (this.documento.Perfil === 'Inspector' || this.esGrabador);

                    if (!this.habilitarGuardar) {
                        this.DisableControlsConsulta();
                    } else {
                        this.editTitle = 'Editar';
                    }
                });
            } else {
                //ALTA

                this.documentosService.getSolicitudDocumentos(id).subscribe(result => {
                    this.solicitudDocumentos = result;

                    this.habilitarUploaderComponentFromLocal = true;

                    this.IdTipoSolicitud = this.solicitudDocumentos.IdTipoSolicitud;
                    this.tituloTipoSolicitud = this.solicitudDocumentos.IdTipoSolicitudDescripcion;
                    this.esClonada =
                        this.solicitudDocumentos.TwSolicitudJerarquia != null &&
                        this.solicitudDocumentos.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;
                    //SI ES RE-IMPORTACION
                    if (this.solicitudDocumentos.EsReImportacion) {
                        this.tituloTipoSolicitud += ' - Re-Importación';
                    }
                    //SI ES PREVIA
                    if (this.solicitudDocumentos.EsPrevia) {
                        if (
                            this.solicitudDocumentos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                            this.solicitudDocumentos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += ' - Previa';
                        }
                    }

                    this.CodigoSolicitud = this.solicitudDocumentos.CodigoSolicitud;
                    this.CodigoTipoSolicitud = this.solicitudDocumentos.CodigoTipoSolicitud;
                    this.IdEstadoSolicitud = this.solicitudDocumentos.IdEstadoSolicitud;
                    this.TipoSolicitudDescripcion = this.solicitudDocumentos.IdTipoSolicitudDescripcion;
                    this.EstadoSolicitudDescripcion = this.solicitudDocumentos.IdEstadoSolicitudDescripcion;
                    this.IdResultadoEnvioMuestrasLaboratorio = this.solicitudDocumentos.IdResultadoEnvioMuestrasLaboratorio;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorio = this.solicitudDocumentos.DescripcionIdResultadoEnvioMuestrasLaboratorio;
                    this.EsPredua = this.solicitudDocumentos.EsPredua;
                });
            }

            this.MegaSizeLimitsCargado$.subscribe(() => {
                this.megaSizeLimit = this.getValorSizeLimit('documentos-edit');
            });
        });

        //p-selectButton
        this.listSiNo = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
        ];
    }

    createForm() {
        this.form = this.fb.group({
            IdTipoDocumentacion: [undefined, Validators.required],
            Texto: '',
            Fecha: '',
            IdPais: null,
            NombreArchivo: ['', Validators.required],
            VisibleInspector: false,
            esRevisado: false,
            DescargarTraces: EnumSiNoTodos.NO,
            Size: 0, //para pasar su valor al Uploader Local
            Guid: '', //para pasar su valor al Uploader Local
        });
    }

    updateForm() {
        this.form.setValue({
            IdTipoDocumentacion: this.documento.IdTipoDocumentacion,
            Texto: this.documento.Texto,
            Fecha: this.documento.Fecha != null ? new Date(this.documento.Fecha) : null,
            IdPais: this.documento.IdPais,
            NombreArchivo: this.documento.NombreArchivo,
            VisibleInspector: !this.documento.VisibleInspector,
            esRevisado: this.documento.Revisado,
            DescargarTraces: this.documento.DocumentDownloadedFromTraces ? EnumSiNoTodos.SI : EnumSiNoTodos.NO,
            Size: this.documento.Size, //para pasar su valor al Uploader Local
            Guid: this.documento.CodigoStorage, //para pasar su valor al Uploader Local
        });

        //pondrá como obligatorios los campos según el tipo de documentación cargado
        this.establecerCamposObligatorios();
    }

    private DisableControlsConsulta() {
        this.editTitle = 'Detalle';

        this.form.controls['IdTipoDocumentacion'].disable();
        this.form.controls['Texto'].disable();
        this.form.controls['Fecha'].disable();
        this.form.controls['IdPais'].disable();
        this.form.controls['NombreArchivo'].disable();
        this.form.controls['VisibleInspector'].disable();
        this.form.controls['esRevisado'].disable();
        this.form.controls['DescargarTraces'].disable();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    onSelectTipoDocumentacion(event: any) {
        if (event) {
            this.establecerCamposObligatorios();

            //resetear habilitarDescargarTraces
            this.form.value.DescargarTraces = EnumSiNoTodos.NO;

            this.inicializarParaSubidaDesdeLocal();

            //de momento se oculta el botón Descargar, si luego selecciona SÍ en Descargar desde TRACES entonces se muestra
            this.habilitarButtonDownloadFileFromTraces = false;
        } else {
            this.requerirTexto = false;
            this.removeValidators('Texto');
            this.requerirFecha = false;
            this.removeValidators('Fecha');
            this.requerirPais = false;
            this.removeValidators('IdPais');
        }
    }

    establecerCamposObligatorios() {
        const idTipoDocumento = this.form.value.IdTipoDocumentacion;

        let seleccionado = this.listTipoDocumentacion?.find(x => x.Id == idTipoDocumento);

        //si columna AttachedTraces de TcTipoDocumentacion es true, preguntar si adjuntar fichero desde local o descargarlo desde TRACES
        this.esTipoDocumentoAttachedTraces = (<TipoDocumentacionViewModel>seleccionado).AttachedTraces ? true : false;

        this.requerirTexto = (<TipoDocumentacionViewModel>seleccionado).RequerirTexto;
        this.requerirFecha = (<TipoDocumentacionViewModel>seleccionado).RequerirFecha;
        this.requerirPais = (<TipoDocumentacionViewModel>seleccionado).RequerirPais;

        if (this.requerirTexto!.valueOf() == true) {
            this.addValidator('Texto', Validators.required);
        } else {
            this.removeValidators('Texto');
        }

        if (this.requerirFecha!.valueOf() == true) {
            this.addValidator('Fecha', Validators.required);
        } else {
            this.removeValidators('Fecha');
        }

        if (this.requerirPais!.valueOf() == true) {
            this.addValidator('IdPais', Validators.required);
        } else {
            this.removeValidators('IdPais');
        }
    }

    onSelectPaisOrigen() {
        //para habilitar o no el botón de Descargar fichero desde TRACES según estén informados los campos obligatorios que se necesitan

        return this.isButtonDownloadFileFromTracesDisabled();
    }

    isButtonDownloadFileFromTracesDisabled() {
        //para habilitar o no el botón de Descargar fichero desde TRACES según estén informados los campos obligatorios que se necesitan

        return this.form.value.IdPais == null || this.form.value.Texto == '';
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/documentos', this.navMenuService.currentSolicitudImportacion.Id]);
    }

    //se recibe el emit desde el componente hijo, Uploader Local, del fichero cargado y ya grabado en BD
    onFileUploaded(uploadedFile: UploadedFileViewModel) {
        this.uploadedFile = uploadedFile;

        if (this.filePendingToPurge !== '') {
            this.documentosService.deleteFile(this.filePendingToPurge).subscribe();
        }
        this.filePendingToPurge = uploadedFile.Guid;

        //en Uploader Local obtenemos el valor para este campo obligatorio en subida local
        this.form.controls['NombreArchivo'].setValue(this.uploadedFile!.Name);

        this.addSuccessMessage('Documento cargado. Recuerde GUARDAR antes de abandonar la pantalla');
    }

    get ficheroSubido(): boolean {
        return this.uploadedFile.Guid !== undefined && this.uploadedFile.Guid !== null && this.uploadedFile.Guid !== '' && !this.uploadedFile.MarkToDelete;
    }

    onFileDeleted(deletedFile: UploadedFileViewModel) {
        this.uploadedFile = deletedFile;
    }

    get formInvalid(): boolean {
        return !this.form.valid || !this.form.dirty || this.form.pristine;
    }

    onChangeSelectDownloadFromTraces(event: any) {
        this.habilitarButtonDownloadFileFromTraces = event.value == 1 ? true : false;

        if (this.habilitarButtonDownloadFileFromTraces) {
            //SUBIDA DESCARGANDO DESDE TRACES (Certificado Fitosanitario transmitido electrónicamente PHYTO/ePhyto --> SÍ)
            this.inicializarParaSubidaDescargandoDesdeTraces();
        } else {
            //SUBIDA LOCAL (Certificado Fitosanitario transmitido electrónicamente PHYTO/ePhyto --> NO)
            this.inicializarParaSubidaDesdeLocal();
        }

        //para descargar de TRACES es necesaria la referencia y el país
        this.requerirPais = this.habilitarButtonDownloadFileFromTraces;

        if (this.requerirPais!.valueOf() == true) {
            this.addValidator('IdPais', Validators.required);
        } else {
            this.removeValidators('IdPais');
        }
    }

    inicializarParaSubidaDesdeLocal() {
        //sólo se inicializa cuando venimos de mostrar grid de documento descargado desde TRACES, así no se transmite este nombre al componente Uploader Local (tiene que aparecer limpio)
        if (this.habilitarGridInfoFileDownloadedFromTraces) {
            this.form.controls['NombreArchivo'].setValue('');
        }
        this.addValidator('NombreArchivo', Validators.required); //para ser NO válido en onSubmit(). Uploader Local tiene este campo obligatorio para controlar que se ha pulsado Cargar

        this.habilitarUploaderComponentFromLocal = true;
        this.habilitarGridInfoFileDownloadedFromTraces = false;

        //Antes de inicializar el objeto, si hubiera algún GUID de alguna carga anterior, ha de asignarse ahora a Old Guid
        if (this.downloadedFileFromTraces!.Guid !== undefined && this.downloadedFileFromTraces!.Guid !== '') {
            //this.allOldGuidCollection.push(this.downloadedFileFromTraces!.Guid);
            this.filePendingToPurge = this.downloadedFileFromTraces!.Guid;
        }

        //ahora inicializar el objeto
        this.downloadedFileFromTraces = new DownloadedFileViewModel();

        //da igual si es alta o edición, si se usa el Uploader Local, este campo adquiere necesariamente este valor
        this.documento.ReferenciaTraces = '0';
    }

    inicializarParaSubidaDescargandoDesdeTraces() {
        this.habilitarUploaderComponentFromLocal = false;
        this.habilitarGridInfoFileDownloadedFromTraces = false;

        if (this.uploadedFile!.Guid !== undefined && this.uploadedFile!.Guid !== '') {
            //this.allOldGuidCollection.push(this.uploadedFile!.Guid);
            this.filePendingToPurge = this.uploadedFile!.Guid;
        }

        this.uploadedFile = new UploadedFileViewModel();

        this.removeValidators('NombreArchivo'); //para ser SÍ válido en onSubmit(). Descargar desde TRACES no visualiza un control input como el Uploader Local y la carga es automática

        //para el Uploader Local. Se inicializa
        this.form.controls['NombreArchivo'].setValue('');

        //da igual si es alta o edición, una vez pulsa en Descargar Desde TRACES, este campo adquiere necesariamente este valor
        this.documento.ReferenciaTraces = '9999999';
    }

    onClickDownloadFileFromTraces() {
        const numeroReferencia = this.form.value.Texto;
        const idPais = this.form.value.IdPais;

        let paisSeleccionado = this.listPais.find(x => x.Id == idPais);
        let convenioIsoTraces = (<PaisViewModel>paisSeleccionado).ConvenioIsoTraces;

        //se descarga el fichero desde TRACES y, sin llegar al cliente de Angular, guardamos desde servidor en BD el documento
        this.documentosService.downloadDocumentoTraces(numeroReferencia, convenioIsoTraces).subscribe(res => {
            //this.allOldGuidCollection.push(this.downloadedFileFromTraces!.Guid);
            this.filePendingToPurge = this.downloadedFileFromTraces!.Guid;

            this.downloadedFileFromTraces.Guid = res.Guid;
            this.downloadedFileFromTraces.Name = this.form.value.Texto;
            this.downloadedFileFromTraces.Size = res.Size;
            this.downloadedFileFromTraces.MarkToDelete = false;

            this.habilitarButtonDownloadFileFromTraces = false; //se oculta el botón de Descarga
            this.habilitarGridInfoFileDownloadedFromTraces = true; //se visualiza el grid con la info del fichero descargado

            this.addSuccessMessage('Documento descargado desde TRACES. Recuerde GUARDAR antes de abandonar la pantalla');
        });
    }

    getSizeKb() {
        return Math.round(this.downloadedFileFromTraces.Size / 1024);
    }

    isDocumentoDescargable() {
        //Columna ReferenciaTraces de tabla TDocumentoSolicitud:
        // 0       --> fichero NO CF no sube a TRACES
        // xxxxxxx --> fichero SÍ CF sí sube a TRACES
        // NULL    --> fichero SÍ CF sí sube a TRACES (falló subida)
        // 9999999 --> fichero SÍ CF no sube a TRACES (porque baja de TRACES)
        if (this.isSolicitante) {
            return this.documento.ReferenciaTraces != '9999999';
        }

        //resto de perfiles que ven Documentos, inspectores y consultas, sí tienen que poder descargarse los documentos
        return true;
    }

    //Es el Delete del grid de documentos descargados desde TRACES. Hay otro Delete en el grid de documentos subidos desde local en Uploader Local
    onDelete() {
        this.downloadedFileFromTraces = new DownloadedFileViewModel();

        this.habilitarGridInfoFileDownloadedFromTraces = false;
        this.habilitarButtonDownloadFileFromTraces = true;
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos del documento');
            return;
        }

        //Validamos si se ha cargado algún documento:
        // this.downloadedFileFromTraces.Name --> Pregunta si cargado documento descargado desde TRACES
        // this.uploadedFile.Name --> Pregunta si cargado documento subido desde Uploader Local
        // this.uploadedFile.MarkToDelete --> Pregunta si cargado documento subido desde Uploader Local. MarkToDelete a True se hace exclusivamente en el componente Uploader Local al pulsar en el
        // icono de borrado. Pero hay una situación en la que sin pulsar ese icono de borrado el archivo no está cargado: estando un fichero local cargado, el usuario elige un tipo de documento
        // con AttachedTraces a TRUE y pulsa SÍ en Descargar Desde TRACES, entonces MarkToDelete es False pero en cambio no hay documento cargado, por eso es necesario preguntar también por
        // this.uploadedFile.Name.
        if (this.downloadedFileFromTraces.Name == '' && (this.uploadedFile.Name == '' || this.uploadedFile.MarkToDelete)) {
            if (this.habilitarButtonDownloadFileFromTraces) {
                this.addErrorMessage('Debe descargar el documento antes de guardar');
            } else {
                this.addErrorMessage('Debe cargar el documento antes de guardar');
            }
            return;
        }

        this.visibilitySpinner = true;

        let documento = new TDocumentoSolicitudViewModel();

        documento.IdTipoDocumentacion = this.form.value.IdTipoDocumentacion;
        documento.IdPais = this.form.value.IdPais;
        documento.Fecha = this.form.value.Fecha;
        documento.Texto = this.form.value.Texto;
        documento.SubidoPorInspector = this.esInspector ? true : false;

        if (this.documento.FechaCreacion != null) {
            documento.FechaCreacion = this.documento.FechaCreacion;
        }

        documento.VisibleInspector = this.editMode
            ? !this.form.value.VisibleInspector
            : !this.isInspector || (this.isGrabador && this.isInspector && this.laHeGrabadoYo)
              ? false
              : !this.form.value.VisibleInspector;

        documento.Revisado = this.editMode
            ? this.form.value.esRevisado
            : !this.isInspector || (this.isGrabador && this.isInspector && this.laHeGrabadoYo)
              ? false
              : this.form.value.esRevisado;

        //documento.VisibleInspector = this.editMode ? documento.VisibleInspector :
        //    (!this.isInspector || (this.isGrabador && this.isInspector && this.laHeGrabadoYo)) ? false
        //        : true;

        documento.IdSolicitud = this.navMenuService.currentSolicitudImportacion.Id;
        documento.Id = this.documento.Id;
        documento.IdUsuario = this.documento.IdUsuario == null ? this.loggedInUser!.Id : this.documento.IdUsuario;
        //se le asigna la colección que alberga todos los posibles Old Guid generados tanto desde el Uploader Local como Descargar Desde TRACES
        //documento.OldCodigoStorageCollection = this.allOldGuidCollection;

        //LOCAL: el solicitante sube el documento desde Uploader local
        if (!this.habilitarGridInfoFileDownloadedFromTraces) {
            documento.NombreArchivo = this.uploadedFile.Name;
            documento.CodigoStorage = this.uploadedFile.Guid;
            documento.Size = this.uploadedFile.Size;
        }
        //REMOTO: el solicitante se descarga el documento desde TRACES
        else {
            documento.NombreArchivo = documento.Texto + '.pdf';
            documento.CodigoStorage = this.downloadedFileFromTraces.Guid;
            documento.Size = this.downloadedFileFromTraces.Size;

            documento.DocumentDownloadedFromTraces = true;
        }

        if (this.editMode) {
            documento.ReferenciaTraces = this.documento.ReferenciaTraces; //si es edición, no perder el valor que tenía este campo dado en servidor al dar de alta

            this.documentosService.editDocumento(documento).subscribe({
                next: () => {
                    this.addSuccessMessage('Documento modificado correctamente');
                    this.filePendingToPurge = '';
                    //this.allOldGuidCollection = new Array<string>();
                    this.uploadedFile = new UploadedFileViewModel();
                    this.visibilitySpinner = false;
                    this.onBack();
                },
                error: error => {
                    this.visibilitySpinner = false;
                    this.catchServerError(error);

                    return of(null);
                },
            });
        } else {
            //Columna ReferenciaTraces de tabla TDocumentoSolicitud:
            // 0       --> fichero NO CF no sube a TRACES
            // xxxxxxx --> fichero SÍ CF sí sube a TRACES
            // NULL    --> fichero SÍ CF sí sube a TRACES (falló subida)
            // 9999999 --> fichero SÍ CF no sube a TRACES (porque baja de Traces)

            documento.ReferenciaTraces = this.esTipoDocumentoAttachedTraces
                ? documento.DocumentDownloadedFromTraces
                    ? '9999999'
                    : documento.ReferenciaTraces
                : '0';

            this.documentosService.createDocumento(documento).subscribe({
                next: res => {
                    //distinguir anexado de fichero local y de fichero descargado de TRACES
                    if (!this.habilitarGridInfoFileDownloadedFromTraces) {
                        if (res.Reference) {
                            if (res.IsOK) {
                                this.addSuccessMessage('Documento añadido y subido a TRACES correctamente');
                            } else {
                                this.addWarningMessage(
                                    'Documento añadido pero no se ha subido a TRACES correctamente. Pruebe a reenviar a TRACES desde el listado de Documentos.',
                                );
                            }
                        } else {
                            this.addSuccessMessage('Documento añadido correctamente');
                        }
                    }
                    //descargado de TRACES directamente
                    else {
                        this.addSuccessMessage('Documento añadido correctamente');
                    }

                    //this.allOldGuidCollection = new Array<string>();
                    this.uploadedFile = new UploadedFileViewModel();
                    this.visibilitySpinner = false;
                    this.filePendingToPurge = '';
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    //if (error?.error[0]?.message === this.mensajeYaExisteCF) {
                    //}
                    return of(null);
                },
            });
        }
    }

    ngOnDestroy(): void {
        if (this.filePendingToPurge !== '') {
            this.documentosService.deleteFile(this.filePendingToPurge).subscribe();
        }
    }
}
